import React, { useState, useEffect, useCallback, useRef } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
	fetchAttempt,
	fetchInstruction,
} from '../../redux/myCourse/myCourse.actions';
import { setErrorMsg } from '../../redux/utilities/utils.actions';
import { minToMs, dateDiff, setRevealTimer } from '../../utils/commonFunctions';
const ContinueCourseBtn = ({
	continueElementDetails,
	element_type,
	attempt_id,
	element_id,
	fetchInstruction,
	completedPercent,
	courseId,
	fetchAttempt,
	setErrorMsg,
}) => {
	let [instructionText, setInstructionText] = useState('');
	let [instructionLink, setInstructionLink] = useState({});

	const timer_continue = useRef(null);
	useEffect(() => {
		return () => {
			clearInterval(timer_continue.current);
		};
	}, []);
	const showError = useCallback(
		(lock_message) => {
			setErrorMsg(lock_message);
		},
		[setErrorMsg],
	);

	const [disableBtn, setDisableBtn] = useState(false);
	const userOrgID = localStorage.getItem('orgID');
	useEffect(() => {
		if (!!continueElementDetails) {
			let link = {};
			if (!!attempt_id) {
				link['onClick'] = () => {
					fetchAttempt(attempt_id);
				};
			} else if (!!element_type) {
				link['data-toggle'] = 'modal';
				const { lock_status, lock_message } = continueElementDetails;
				if (!!lock_status) {
					link['onClick'] = () => {
						showError(lock_message);
					};
				} else {
					link['onClick'] = () => {
						fetchInstruction(element_id, courseId);
					};

					if (element_type === 'W') {
						link['data-target'] = '#webisode-next-instruction-popup';
					} else if (element_type === 'S') {
						link['data-target'] = '#summativetest-next-instruction-popup';
					} else if (element_type === 'F') {
						link['data-target'] = '#formative-next-instruction-popup';
					}
				}
			}

			if (
				Object.keys(continueElementDetails).length === 0 ||
				completedPercent === 0
			) {
				setInstructionText('GET STARTED');
			} else if (completedPercent === 100) {
				setInstructionText('REDO');
			} else {
				setInstructionText('CONTINUE');
			}
			setInstructionLink(link);
		}
	}, [
		attempt_id,
		completedPercent,
		continueElementDetails,
		courseId,
		element_id,
		element_type,
		fetchAttempt,
		fetchInstruction,
		setInstructionLink,
		setInstructionText,
		showError,
	]);

	useEffect(() => {
		const { reveal_date, reveal_time } = continueElementDetails;

		// let reveal_date = '2021-03-11';
		// let reveal_time = '09:36:20';

		let { reveal } = setRevealTimer(
			reveal_date,
			reveal_time,
			setDisableBtn,
			false,
		);

		if (reveal > 0) {
			setDisableBtn(true);
		}
	}, [continueElementDetails]);

	return (
		<>
	{/*	{courseId != 507 ? (
		<div
			className={`btn-success course_continue_progress_btn ${
				disableBtn ? 'disabledElement' : ''
			}`}
			{...instructionLink}
		>
			{instructionText}
		</div>
		): null}*/}
		<div>
		{courseId == 507 ? (
			<>
			<div className="your_progress_title">IELTS Course Outline</div>
			<a target="_blank" href="https://storage.googleapis.com/assets.thehindustep.in/files/IELTS-Course-Outline.pdf" className="btn btn-md btn-danger"><i className="fa fa-download"></i> Download</a>
			</>
		): null}

		{userOrgID == 2615 && courseId == 315 ? (
			<>
			<br/>
			<div className="your_progress_title">Student Workbook</div>
			<a target="_blank" href="https://storage.googleapis.com/assets.steptest.in/downloads/student-workbook.pdf" className="btn btn-md btn-danger"><i className="fa fa-download"></i> Download</a>
			<br/><br/>
			<div className="your_progress_title">Trainer Manual</div>
			<a target="_blank" href="https://storage.googleapis.com/assets.steptest.in/downloads/trainer-manual.pdf" className="btn btn-md btn-danger"><i className="fa fa-download"></i> Download</a>
			</>
		): null}

		</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const {
		completedPercent,
		continueElementDetails,
	} = state.rootReducer.myCourse;
	const {
		element_type,
		element_id,
		attempt_id,
	} = state.rootReducer.myCourse.continueElementDetails;
	const { courseId } = state.rootReducer.loginDetails;
	return {
		element_type,
		attempt_id,
		element_id,
		completedPercent,
		continueElementDetails,
		courseId,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchAttempt: (attemptId, review = false) =>
			dispatch(fetchAttempt({ attemptId, review })),
		fetchInstruction: (elementId, courseId, isReview = false) =>
			dispatch(fetchInstruction({ elementId, courseId, isReview })),
		setErrorMsg: (msg) => dispatch(setErrorMsg(msg)),
	};
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
	ContinueCourseBtn,
);
